import React, { useState } from 'react';
import { useEffect } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'react-headless-accordion';
import { IoIosArrowBack } from 'react-icons/io';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Accordions = ({ phoneNumber, email, days, hours }) => {



  function formatIsraeliPhoneNumber(phoneNumber) {
    // Remove all non-digit characters from the phone number
    const cleanedNumber = phoneNumber.replace(/\D/g, "");

    // Check if the number starts with "972" and remove it if present
    const formattedNumber = cleanedNumber.startsWith("972") ? cleanedNumber.slice(3) : cleanedNumber;

    // Insert dashes in the appropriate places and add a leading "0"
    const formattedWithZero = `0${formattedNumber.slice(0, 2)}-${formattedNumber.slice(2, 5)}-${formattedNumber.slice(5)}`;

    return formattedWithZero;
  }


  const handleClick = () => {
    window.location.href = `mailto:${email}`;
  };

  var formattedPhoneNumber = formatIsraeliPhoneNumber(phoneNumber);

  const [rotationStates, setRotationStates] = useState({});

  const toggleRotation = (accordionIndex) => {
    setRotationStates((prevState) => ({
      ...prevState,
      [accordionIndex]: !prevState[accordionIndex],
    }));
  };

  const accordionTransitionDuration = 800; // Set the same duration as the accordion transition

  return (
    <div className='py-4' >
      <div className='max-w-[450px] card border-transparent bg-transparent shadow-xl mx-auto'>
        <div>

          <div data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="0">
            <Accordion
              className='hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-4 border-borderBtn text-2xl font-semibold p-4 m-4 shadow-lg '
              transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
            >
              <AccordionItem>
                <AccordionHeader
                  className='items-center flex justify-between'
                  onClick={() => toggleRotation(0)}
                >
                  <IoIosArrowBack
                    className={rotationStates[0] ? 'rotate-90' : ''}
                    style={{ transition: `transform 0.4s ease-in-out` }}

                  />
                  <h3 dir='rtl' className={`accordion-title`}>מה תמצאו בסטודיו פז?</h3>
                </AccordionHeader>

                <AccordionBody className='card-normal text-accordionText'>
                  <div className='accordion-body'>
                    <div className='card shadow-xl mx-auto'>
                      <div className='text-right p-4 text-[#333]'>


                        <li className='text-lg font-normal' dir='rtl'>פילאטיס עיצוב וחיטוב</li>
                        <li className='text-lg font-normal' dir='rtl'>פילאטיס מתחילות</li>
                        <li className='text-lg font-normal' dir='rtl'>פילאטיס מתקדמות</li>
                        <li className='text-lg font-normal' dir='rtl'>פילאטיס בונה עצם</li>
                        <li className='text-lg font-normal' dir='rtl'>שיעורי יוגה</li>
                        <li className='text-lg font-normal' dir='rtl'>יועצת תזונה לאורח חיים בריא</li>





                      </div>
                    </div>
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          <div data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="0">
            <Accordion
              className='hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-4 border-borderBtn text-2xl font-semibold p-4 m-4 shadow-lg'
              transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
            >
              <AccordionItem>
                <AccordionHeader
                  className='items-center flex justify-between'
                  onClick={() => toggleRotation(1)}
                >
                  <IoIosArrowBack
                    className={rotationStates[1] ? 'rotate-90' : ''}
                    style={{ transition: `transform 0.4s ease-in-out` }}

                  />
                  <h3 className={`accordion-title`}>תקשורת ושעות פעילות</h3>
                </AccordionHeader>

                <AccordionBody className='card-normal text-accordionText'>
                  <div className='accordion-body'>
                    <div className='card shadow-xl mx-auto text-right '>
                      <div className='text-right p-4 text-[#333]'>
                        <p className='font-medium text-base my-1'>טלפון</p>
                        <a href={`tel:${phoneNumber}`} className='text-lg font-normal' target="_blank" >
                          {formattedPhoneNumber}
                        </a>
                        <p className='font-medium text-base my-1'>מייל</p>
                        <a href={`mailto:${email}`} className='text-lg font-normal' onClick={handleClick} target="_blank" >
                          {email}
                        </a>
                        <p className='font-semibold text-xl mb-1 mt-4'>שעות פעילות</p>
                        <p className='font-medium text-base mb-1 mt-2' dir='rtl'>ימים {days}</p>
                        <p className='text-lg font-normal'>{hours}</p>
                        <p className='font-medium text-base mb-1 mt-2' dir='rtl'>יום ו'</p>
                        <p className='text-lg font-normal' dir=''>08:30 - 10:30</p>
                        <p className='font-medium text-base mb-1 mt-2' dir='rtl'>מוצ"ש</p>
                        <p className='text-lg font-normal' dir=''>20:00 - 22:00</p>




                      </div>
                    </div>
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>

          {/* <div data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="0">
            <Accordion
              className='hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-yellow-100 border-4 border-yellow-100 text-2xl font-semibold p-4 m-4 shadow-lg '
              transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
            >
              <AccordionItem>
                <AccordionHeader
                  className='items-center flex justify-between'
                  onClick={() => toggleRotation(0)}
                >
                  <IoIosArrowBack
                    className={rotationStates[0] ? 'rotate-90' : ''}
                    style={{ transition: `transform 0.4s ease-in-out` }}

                  />
                  <h3 className={`accordion-title`}>לימודי מיקרובליידינג ועיצוב גבות</h3>
                </AccordionHeader>

                <AccordionBody className='card-normal text-accordionText'>
                  <div className='accordion-body'>
                    <div className='card shadow-xl mx-auto'>
                      <div className='text-right p-4'>
                        <p className='font-semibold text-xl mb-1 mt-4 text-yellow-100' dir='rtl'>הלימודים מחולקים ל3 קורסים:</p>
                        <br />


                        <li className='text-lg font-normal text-gray-' dir='rtl'>קורס מיקרובליידינג פרטני של שישה מפגשים אישיים כולל 2 מפגשים מעשיים עם מודליסטיות.</li>
                        <br />
                        <li className='text-lg font-normal' dir='rtl'>קורס עיצוב גבות של 3 מפגשים כולל 2 מפגשים מעשיים עם מודליסטיות. שיטה קלה ומדוייקת לעיצוב גבות מושלם ומותאם אישית לכל לקוחה.</li>
                        <br />
                        <li className='text-lg font-normal text-yellow-100' dir='rtl'>קורס פרימיום של עיצוב גבות ומיקרובליידינג בליווי של ענבר אמון לכל החיים.</li>

                      </div>
                    </div>
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div> */}

        </div>
      </div></div>

  );
};

export default Accordions;
